export function SoftField() {
  return (
    <div className="dx-ml-field" aria-hidden="true">
      <div className="dx-ml-field__glow dx-ml-field__glow--a" />
      <div className="dx-ml-field__glow dx-ml-field__glow--b" />
      <div className="dx-ml-field__glow dx-ml-field__glow--c" />
      <svg className="dx-ml-field__waves" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
        <path d="M-160 40C120 -80 300 200 580 70C860 -60 1100 140 1580 20V940H-160V40Z" fill="#5b9be8" opacity="0.38" />
        <path d="M-160 180C180 40 400 320 700 170C1000 20 1220 260 1580 140V940H-160V180Z" fill="#7eb3f0" opacity="0.5" />
        <path d="M-160 340C220 180 460 460 760 310C1060 160 1280 400 1580 290V940H-160V340Z" fill="#a8cdf7" opacity="0.65" />
        <path d="M-160 500C260 360 500 580 820 470C1140 360 1320 560 1580 460V940H-160V500Z" fill="#cfe3fa" opacity="0.8" />
      </svg>
    </div>
  );
}
